import React, {
  createContext,
  PropsWithChildren,
  useContext,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { AppNavigationService } from 'services/navigation';

const AppNavigationContext = createContext<AppNavigationService | null>(
  null
);

export const AppNavigationProvider = ({
  children,
}: PropsWithChildren): React.ReactElement => {
  const navigate = useNavigate();
  const navigationService = new AppNavigationService(navigate);

  return (
    <AppNavigationContext.Provider value={navigationService}>
      {children}
    </AppNavigationContext.Provider>
  );
};

export const useAppNavigation = (): AppNavigationService => {
  const context = useContext(AppNavigationContext);
  if (!context) {
    throw new Error(
      'useAppNavigation must be used within AppNavigationProvider'
    );
  }
  return context;
};
